import { BaseApiService } from "@mirage/services/BaseApiService";
import { IConsultationService } from "@shared/publicportal/services/IConsultationService";
import { GetCommentsRequest } from "@shared/publicportal/contracts/Comments";
import {
    CreateConsultationResponse,
    CreateConsulteeCommentRequest,
    GetPublicConsulteeCommentsResponse,
    GetUserConsulteeCommentsResponse,
} from "@shared/publicportal/contracts/ConsulteeComments";

export class ConsultationsService extends BaseApiService implements IConsultationService {
    constructor() {
        super("publicportal/consultations");
    }

    async create(request: Omit<CreateConsulteeCommentRequest, "user">): Promise<CreateConsultationResponse> {
        const response = await this.httpInstance().post("/", request);
        return response.data;
    }

    async getUserConsultations(request: Omit<GetCommentsRequest, "publicUserId">): Promise<GetUserConsulteeCommentsResponse> {
        const response = await this.httpInstance().get(`/userConsultations/${request.paId}`);
        return response.data;
    }

    async getPublicConsultations(paId: number): Promise<GetPublicConsulteeCommentsResponse> {
        const response = await this.httpInstance().get(`/${paId}`);
        return response.data;
    }
}
